export default {
  title: 'Data e ora',
  buttons: {
    done: 'Fatto',
  },
};
